export function LabelIcon({ color = '#D00B49' }: { color?: string }) {
  return (
    <div className="combo-single-product__label-image">
      <svg
        width="124"
        height="106"
        viewBox="0 0 124 106"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 14.5903V60.0331C0 65.2006 2.03703 70.1552 5.68545 73.8028L59.1956 127.301C66.7964 134.9 79.1098 134.9 86.7107 127.301L127.299 86.7213C134.9 79.1222 134.9 66.8116 127.299 59.2124L73.7892 5.71455C70.1408 2.06696 65.185 0.0303961 60.0165 0.0303961L14.5937 0C6.53675 0 0 6.53525 0 14.5903ZM34.0519 24.3172C36.6322 24.3172 39.1068 25.342 40.9314 27.1662C42.756 28.9903 43.781 31.4644 43.781 34.0441C43.781 36.6238 42.756 39.0979 40.9314 40.9221C39.1068 42.7462 36.6322 43.771 34.0519 43.771C31.4716 43.771 28.9969 42.7462 27.1724 40.9221C25.3478 39.0979 24.3228 36.6238 24.3228 34.0441C24.3228 31.4644 25.3478 28.9903 27.1724 27.1662C28.9969 25.342 31.4716 24.3172 34.0519 24.3172Z"
          fill={color}
          fill-opacity="0.05"
        />
      </svg>
    </div>
  );
}
